module.exports = __webpack_public_path__ + "static/media/katelyn.6f4777ca.png";